export default function AboutStats() {
  const stats = [
    { value: '50+', label: 'Workflows Deployed' },
    { value: '3x', label: 'Avg. Efficiency Gain' },
    { value: '12+', label: 'Industries Served' },
    { value: '98%', label: 'Client Retention' },
  ];

  return (
    <section className="bg-secondary py-12 border-y border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, index) => (
            <div key={index}>
              <div className="text-3xl md:text-4xl font-display text-primary font-bold mb-2">
                {stat.value}
              </div>
              <div className="text-muted-foreground text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}